import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("获取最新工资表成本")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改")

import {  ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox, radioButtonProps } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/project_cost': fetchList,
  // 薪酬项目维护(按种类划分)
  'GET/salary_categories': salary_categoriesApi,
  // 获取最新工资表成本
  'POST/project_cost/salary': getSalaryApi,
  // 修改分摊日期
  'PATCH/project_cost': project_costApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "时间",
    value: '2023-01-07',
    upKey: 'date',
    props: { clearable: false, 'default-value': null, },
    timeCb: (date: string): void => {
      searchHandle({...MI_params, date})
    },
  },
  {
    type: 'SELECT',
    label: '导入项目',
    value: '',
    upKey: 'categoryId',
    options: [],
    placeholder: '请选择项目',
    selectFunc: salary_categoriesApi,
    seleProps: { label: 'name', valueName: 'id', },
    funcParam: {type: 'ALL'},
    props: { placeholder: '请选择项目', clearable: true },
    selectCb: (categoryId: string): void => {
      searchHandle({...MI_params, categoryId})
    },
  },
  {
    label: "姓名",
    value: '',
    upKey: 'key',
    props: { clearable : true }
  },
])
const searchHandle = (params: any) => {
  fetchData(params)
}

// 添加
const getConfig = ref([
  {
    type: "TIME",
    label: "时间",
    value: '',
    upKey: 'date',
    props: {
      clearable: false,
      'default-value': null,
    }
  },
])
const getFg = ref<boolean>(false)
const getSalaryHandle = () => {
  MI_modifyForm({}, getConfig, getFg, async(params: any) => {
    await getSalaryApi(params)
    ElMessage.success('获取成功')
    getFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  {
    type: "TIME",
    label: "受益开始日期",
    value: '',
    upKey: 'startDate',
    rule: [{ required: true, message: '请选择受益开始日期', trigger: 'change' }],
    props: {
      clearable: true,
      'default-value': null,
    }
  },
  {
    type: "TIME",
    label: "受益结束日期",
    value: '',
    upKey: 'endDate',
    rule: [{ required: true, message: '请选择受益结束日期', trigger: 'change' }],
    props: {
      clearable: true,
      'default-value': null,
    }
  },
])
const modifyHandle = (row: any) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: any) => {
    await project_costApi({...row, ...params})
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    } else if(index === 3){
      let values = data.map((item: any) => Number(item[column.property]))
      sums[3] = getNumber(values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
    } else {
      sums[index] = ''
    }
  })

  return sums
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
        initSearch: true,
        title: true,
        searchConfig: searchConfig.value,}, { onSearchFn: searchHandle }), {
      btnGroup: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getSalaryHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })), [
          [_directive_permission, 'Write']
        ])
      ]),
      _: 1
    }, 16),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      "show-summary": "",
      "summary-method": getSummaries,
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "项目名称",
          prop: "categoryName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发放日期",
          prop: "date",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "受益开始日期",
          prop: "startDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "受益结束日期",
          prop: "endDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "获取最新工资表成本",
      width: "30%",
      modelValue: getFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((getFg).value = $event))
    }, {
      default: _withCtx(() => [
        (getFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: getConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})